import ManagedSection from "./ManagedSection.js";
export default ManagedSection;
